import React from 'react';
import {
   Datagrid,
   List,
   TextField,
   ReferenceField,
   TextInput,
   ReferenceArrayField,
   SingleFieldList,
   ChipField,
} from 'react-admin';
import { TablePagination } from '../../../helperComponents/TablePagination';
import { TitleAboveTable } from '../../../helperComponents/TitleAboveTable';
import { EmptyBulkActionButtons } from '../../../helperComponents/EmptyBulkActionButtons';
import { searchInputWidth } from '../../../../helpers';
import { useRowStyle } from '../../../../hooks/useRowStyle';
import { ToolBarRowStyleToggle } from '../../../helperComponents/ToolBarRowStyleToggle';

export const DefaultGoogleCampaignSettingsList = props => {
   const rowClassName = useRowStyle();

   return (
     <>
        <TitleAboveTable title="Google default campaigns"/>
        <List {...props}
              className="list-admin-wrapper"
              title=" "
              actions={<ToolBarRowStyleToggle/>}
              pagination={<TablePagination/>}
              filters={[
                <TextInput source="q"
                           label="ID, Affiliate ID, Offer ID, Default campaign ID, Report ID"
                           alwaysOn
                           sx={{
                              width: searchInputWidth,
                           }}
                />,
              ]}
        >
           <Datagrid rowClick="edit" bulkActionButtons={<EmptyBulkActionButtons/>} className={`${rowClassName} datagrid-content`}>
              <TextField source="id" label="ID"/>
              <TextField source="affiliate_id" label="Affiliate ID"/>
              <ReferenceField
                reference="reference_fields/affiliate_names"
                source="affiliate_id"
                label="Affiliate name"
                link={false}>
                 <TextField source="affiliate"/>
              </ReferenceField>
              <TextField source="offer_id" label="Offer ID"/>
              <ReferenceField
                reference="reference_fields/offer_names"
                source="offer_id"
                label="Offer name"
                link={false}>
                 <TextField source="offer"/>
              </ReferenceField>
              <TextField source="campaign_default" label="Default campaign  ID"/>
              <ReferenceField
                reference="reference_fields/campaign_names"
                source="campaign_default"
                label="Campaign name"
                link={false}>
                 <TextField source="campaign"/>
              </ReferenceField>
              <TextField source="report_ids" label="Report IDs"/>
              <ReferenceArrayField
                reference="reference_fields/report_names"
                source="report_ids"
                label="Report Names">
                 <SingleFieldList linkType={false}>
                    <ChipField source="report_name" onClick={e => e.preventDefault()}/>
                 </SingleFieldList>
              </ReferenceArrayField>
           </Datagrid>
        </List>
     </>
   );
};
